import { addItemToCollection } from "directus/src/operations";

export async function createFunction({ item }) {
  try {
    const data = await addItemToCollection("functions", item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
